import React, {useState, useEffect} from 'react'
import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import Blog from '../Pages/Blog'
import BlogDetails from '../Pages/BlogDetails'
import CategoryDetails from '../Pages/CategoryDetails'
import Contact from '../Pages/Contact'
import Home from '../Pages/Home'
import Protfolio from '../Pages/Protfolio'
import PortfolioDetails from '../Pages/PortfolioDetails'
import ErrorPage from '../Pages/ErrorPage'
import Team from '../Pages/Team'
import { variables } from './Variable'
import Careers from '../Pages/Careers'
import CatageoryCopy from '../Pages/CategoriesCopy'
import VR from '../Pages/VR'
import Content from '../Pages/Content'

const AppRoute = (props) => {
    const [menu, setMenu] = useState([]);
    const getMenu = () => {
        fetch(variables.API_URL + "Menu/GetMenues", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => Response.json())
            .then((Result) => {
                setMenu(Result);
            });
    }

    useEffect(() => {
        getMenu()
    }, []);

    return (
        <>
            <Routes>
                <Route path='/Portfolio-Details/:AlbumId' element={<PortfolioDetails/>}></Route>
                <Route path="/:MenuTitle/4" element={<Home />} ></Route>
                <Route path='/:MenuTitle/:MenuId' element={<CatageoryCopy />}></Route>
                <Route path='/:MenuTitle/7' element={<Protfolio/>}></Route>
                {/* <Route path='/:MenuTitle/8' element={<Blog/>}></Route> */}
                <Route path='/:MenuTitle/9' element={<Contact/>}></Route> 
                <Route path='/:MenuTitle/31' element={<Careers />}></Route>
                <Route path='/VR' element={<VR />}></Route>
                <Route path='/' element={<Home/>}></Route>
                <Route path='/:MenuTitle/:MenuId/c/:ContentTitle/:ContentId' element={<CategoryDetails/>}></Route>
                
                <Route path='/Blog-Details' element={<BlogDetails/>}></Route>
                <Route path='/:language/v/Team/:MenuId' element={<Team/>}></Route>
                <Route path='/Content/:Search' element={<Content/>}></Route>
                <Route path='*' element={<ErrorPage/>}></Route>
            </Routes>
        </>
    )
}

export default AppRoute